import React, { useEffect, useState, useRef, useCallback  } from 'react';
import {Link, useParams, useNavigate } from 'react-router-dom';
import SockJS from 'sockjs-client';
import { Client } from '@stomp/stompjs';
import axios from 'axios';
import '../../css/private/inbox.css';
import SideBar from '../components/SideBar';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Cookies from 'js-cookie';

const InboxTemplate = ({}) => {
  
	const ServerApiDomain = process.env.REACT_APP_SPRING_SERVER_API_DOMAIN;
  const navigate = useNavigate();
  const { recipientId } = useParams();
  const [recipients, setRecipients] = useState([]);

  
  const CookietId = Cookies.get('current_Id');
  const CookieMetaSystemUserToken = Cookies.get('meta_system_user_token');
  const CookieAccountId = Cookies.get('current_accountId');
  const CookieAccountName = Cookies.get('current_accountName');
  const CookieAccountEmail = Cookies.get('current_accountEmail');
  const CookieWabaId = Cookies.get('CookieWabaId');
  
  const [FullPageloading, setFullPageloading] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);
  const [pageTwo, setPageTwo] = useState(0);
  const [hasMoreTwo, setHasMoreTwo] = useState(true);
  const [loadingMoreTwo, setLoadingMoreTwo] = useState(false);
  const peopleListRefTwo = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [conversations, setConversations] = useState([]);
  const [page, setPage] = useState(0);
  const loaderRef = useRef(null);
  const [client, setClient] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState('');
  const [loadingOlder, setLoadingOlder] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const messagesEndRef = useRef(null);
  const chatBoxRef = useRef(null);
  const pageRef = useRef(0);
  const isPrependingRef = useRef(false);

  // Replace username with dynamic if needed
  const username = CookieWabaId;

    const [open, setOpen] = useState(false);
      const [selectedId, setSelectedId] = useState(null);
    
    const handleClickOpen = (id) => {
          setSelectedId(id);
          setOpen(true);
      };
  
      const handleCloseDeleteModal = () => {
          setOpen(false);
          setSelectedId(null);
      };
        const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

    
  
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  // Reset inbox when recipient changes
  useEffect(() => {
    setMessages([]);
    setHasMore(true);
    pageRef.current = 0;
    if (client) {
      client.deactivate();
      setClient(null);
    }
  }, [recipientId]);
  // Fetch older messages with deduplication
  const fetchOldMessages = async () => {
    if (!hasMore || loadingOlder) return;
    setLoadingOlder(true);
    try {
      const pageToLoad = pageRef.current;
      const { data } = await axios.get(
        `${ServerApiDomain}/whatsapp-message/all?pageNumber=${pageToLoad}&pageSize=10&sortOrder=desc&recipientId=${recipientId}&username=${username}`
      );
      const newMessages = data.content.reverse();

      setHasMore(!data.lastPage);
      pageRef.current = data.pageNumber + 1;

      if (newMessages.length) {
        isPrependingRef.current = true;
        setMessages(prev => {
          const merged = [...newMessages, ...prev];
          const unique = merged.filter(
            (msg, idx, arr) => arr.findIndex(m => m.messageId === msg.messageId) === idx
          );
          return unique;
        });
      }
    } catch (err) {
      console.error('Fetch old messages error:', err);
    } finally {
      setLoadingOlder(false);
    }
  };

  // Set up WebSocket and load initial messages
  useEffect(() => {
    if (!recipientId) return;
    const socket = new SockJS('https://www.aadow.com:8080/ws');
    const stompClient = new Client({
      webSocketFactory: () => socket,
      onConnect: () => {
        stompClient.subscribe(`/topic/messages/${recipientId}`, ({ body }) => {
          const msg = JSON.parse(body);
          setMessages(prev => [...prev, msg]);
        });
      }
    });

    stompClient.activate();
    setClient(stompClient);

    (async () => {
      await fetchOldMessages();
      if (chatBoxRef.current) {
        chatBoxRef.current.scrollTop = chatBoxRef.current.scrollHeight;
      }
    })();

    return () => stompClient.deactivate();
  }, [recipientId]);

  // Auto-scroll logic
  useEffect(() => {
    if (isPrependingRef.current) {
      isPrependingRef.current = false;
      return;
    }
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  // Infinite scroll for older messages
  useEffect(() => {
    const onScroll = async () => {
      if (!hasMore || loadingOlder) return;
      const box = chatBoxRef.current;
      if (!box) return;
      if (box.scrollTop < 10) {
        const prevHeight = box.scrollHeight;
        await fetchOldMessages();
        const newHeight = box.scrollHeight;
        box.scrollTop = newHeight - prevHeight;
      }
    };

    const box = chatBoxRef.current;
    box?.addEventListener('scroll', onScroll);
    return () => box?.removeEventListener('scroll', onScroll);
  }, [hasMore, loadingOlder]);

  // Send message
  const sendMessage = async () => {
  if (!messageInput.trim()) return;

  const messageData = {
    messaging_product: 'whatsapp',
    to: recipientId,
    type: 'text',
    text: { body: messageInput }
  };

  try {
    // Step 1: Send message via WhatsApp API
    const response = await axios.post(
      `https://graph.facebook.com/v19.0/${CookieWabaId}/messages`,
      messageData,
      {
        headers: {
          Authorization: `Bearer EAAXOdC6dZBF8BO9ZAIkCz6zxZCf2QvkFliNS8FITHVMuXJOcQVjUiFCuANY60DzKQwR1cagEmHjxHhq3N6nly70AAZAoDHduRihL0EWgBSlfjrw1vDXLMp2jDjXZAG1pyLrLeN6c47L9jFKjdoU4wrUTQSZCBai0Xxv3NcOGOBB71XcpKROtjO4wZCiZA1vqwnbR2gZDZD`,
          'Content-Type': 'application/json'
        }
      }
    );

    // Step 2: Get real message ID from Meta
    const officialMessageId = response.data?.messages?.[0]?.id;

    if (!officialMessageId) {
      console.warn('⚠️ No message ID returned by Meta');
      return;
    }

    console.log('✅ Official Message ID:', officialMessageId);

    // Step 3: Create message payload with official ID
    const localMessage = {
      conversationId: username,
      messageBody: messageInput,
      sentBy: 'business',
      username,
      messageId: officialMessageId, // ✅ Use official messageId
      senderId: 'whatsapp',
      recipientId,
      messageType: 'text',
      billable: false,
      messageStatus: 'SENT',
      pricingModel: 'CBP',
      category: 'UTILITY',
      timestamp: new Date().toISOString()
    };

    // Step 4: Push to WebSocket
    if (client && client.connected) {
      client.publish({
        destination: '/app/chat/send',
        body: JSON.stringify(localMessage)
      });
    }

    await axios.patch(`${ServerApiDomain}/whatsapp-conversation/update`, {
      lastMessage: messageInput,
      username,
      recipientId
    }).catch(err => {
      console.error('❌ PATCH error:', err?.response?.data || err.message);
    });

    

    setMessageInput('');

  } catch (error) {
    console.error('❌ WhatsApp API error:', error?.response?.data || error.message);
  }
};



  const getRandomColor = (id) => {
        const colors = ["#bd0000", "#bd9100", "#2cbd00", "#00b7bd", "#003cbd", "#9d00bd", "#bd0068"];

        const index = Math.abs(hashCode(id)) % colors.length;
        return colors[index];
    };
    
    const hashCode = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return hash;
    };

    const fetchImage = async () => {
       
    };

    const formatTimestamp = (timestamp) => {
  // Step 1: Parse the UTC time
  const inputDateUTC = new Date(timestamp);

  // Step 2: Convert UTC to IST using toLocaleString with Asia/Kolkata timezone
  const istString = inputDateUTC.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
  const istDate = new Date(istString);

  // Step 3: Get IST "now", "today", and "yesterday"
  const now = new Date();
  const istNow = new Date(now.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

  const today = new Date(istNow);
  today.setHours(0, 0, 0, 0);

  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  // Step 4: Format accordingly
  if (istDate >= today) {
    // Today's message → show only time
    return istDate.toLocaleTimeString('en-IN', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
      timeZone: 'Asia/Kolkata'
    });
  } else if (istDate >= yesterday) {
    return 'Yesterday';
  } else {
    return istDate.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      timeZone: 'Asia/Kolkata'
    });
  }
};


    const [pageNumber, setPageNumber] = useState(0);
    const [lastPage, setLastPage] = useState(false);


  const [activeSearch, setActiveSearch] = useState(false);

  const pageSize = 10;

  const fetchConversations = async () => {
  if (lastPage || loading) return;
  setLoading(true);

  const baseUrl = `${ServerApiDomain}/whatsapp-conversation`;
  const url = activeSearch
    ? `${baseUrl}/search?username=${username}&searchTerm=${searchTerm}&pageSize=${pageSize}&pageNumber=${pageNumber}`
    : `${baseUrl}/unique-recipients?username=${username}&pageSize=${pageSize}&pageNumber=${pageNumber}`;

  try {
    const response = await axios.get(url);
    const data = response.data;

    setConversations((prev) => {
      const existingIds = new Set(prev.map((c) => c.id));
      const newConvs = data.content.filter((c) => !existingIds.has(c.id));
      return [...prev, ...newConvs];
    });

    setLastPage(data.lastPage);
  } catch (error) {
    console.error('Error fetching conversations:', error);
  } finally {
    setLoading(false);
  }
};


  // Initial & Pagination Fetch
 useEffect(() => {
  fetchConversations();
}, [pageNumber, activeSearch]);

useEffect(() => {
  setPageNumber(0);
  setConversations([]);
  setLastPage(false);
}, [activeSearch, searchTerm]);


  // Infinite Scroll Trigger
  const observer = useRef();
const lastElementRef = useCallback(
  (node) => {
    if (loading) return;

    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && !lastPage) {
        setPageNumber((prev) => prev + 1);
      }
    });

    if (node) observer.current.observe(node);
  },
  [loading, lastPage]
);

  const handleSearchInput = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setActiveSearch(value.trim().length > 0);
  };

  const handleDeleteConversation = async () => {
    setFullPageloading(true);
      handleCloseDeleteModal();
  try {
    const userId = CookieWabaId;
    const recipientId1 = recipientId; // For conversation
    const recipientId2 = recipientId; // For messages

    // First API call
    const response1 = await fetch(`${ServerApiDomain}/whatsapp-conversation/${userId}/delete?recipientId=${recipientId1}`, {
      method: 'DELETE',
    });

    console.log('Conversation delete response:', response1);

    if (!response1.ok) {
      const errorText = await response1.text();
      throw new Error(`Failed to delete conversation: ${response1.status} - ${errorText}`);
    }

    // Second API call
    const response2 = await fetch(`${ServerApiDomain}/whatsapp-message/${userId}/delete/all?recipientId=${recipientId2}`, {
      method: 'DELETE',
    });

    console.log('Messages delete response:', response2);
window.location.href = '/whatsapp/inbox/all';

      
    setFullPageloading(false);

  } catch (error) {
    console.error('Error:', error.message);
    alert(error.message);
  }
};
const formatDateTimestamp = (timestamp) => {
  let inputDate;

  if (timestamp && timestamp.trim() !== '') {
    // Convert 'YYYY-MM-DD HH:mm:ss' to ISO UTC format
    const utcString = timestamp.replace(' ', 'T') + 'Z';
    inputDate = new Date(utcString);
  } else {
    // Use current date-time in IST
    const nowUTC = new Date();
    const istString = nowUTC.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' });
    inputDate = new Date(istString);
  }

  const options = {
    timeZone: 'Asia/Kolkata',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };

  const formattedParts = inputDate.toLocaleString('en-IN', options).split(',');
  return `${formattedParts[0].trim()}, ${formattedParts[1].trim()}`;
};




  
    

  return (
    <SideBar>
      {/* FULL-PAGE LOADING BACKDROP */}
     <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={FullPageloading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
      

      <div className="inbox-area">
        <div className="chat-container">
          
          {/* --- LEFT: PEOPLE / CONTACTS LIST --- */}
          <div className="people-area">
            <div className="header-area ">
               <input
                  type="text"
                  className="search-box d-none"
                  placeholder="Search for Phone Number…"
                  value={searchTerm}
                  onChange={handleSearchInput}
                  autoComplete="off"
                />
              <h3 className="title pb-2">Messages</h3>
            </div>
            
              <div className="people-list-area" style={{ height: "92vh", overflowY: "auto" }}>
                    {conversations.map((conv, index) => {
                      const isLast = index === conversations.length - 1;

                      const content = (
                        <div
                          className={`text-decoration-none ${conv.recipientId === recipientId ? "active-tab" : ""}`}
                          onClick={() => navigate(`/whatsapp/inbox/${conv.recipientId}`)}
                        >
                          <div className="chat-item">
                            <div
                              className="chat-avatar"
                              style={{ backgroundColor: getRandomColor(conv.recipientId) }}
                            >
                              <img
                                src="https://www.aadow.com/icons/profile.png"
                                alt="User Avatar"
                                className="chat-img"
                              />
                            </div>
                            <div className="chat-details">
                              <div className="chat-header">
                                <span className="chat-name">+{conv.recipientId}</span>
                                <span className="chat-time">
                                  {formatTimestamp(conv.lastMessageAt)}
                                </span>
                              </div>
                              <p className="chat-preview">
                                {conv.sentBy === 'business' ? `You: ${conv.lastMessage || "No messages yet"}` : conv.lastMessage || "No messages yet"}
                              </p>
                            </div>
                          </div>
                        </div>
                      );

                      return (
                        <div
                          key={conv.id}
                          ref={isLast ? lastElementRef : null}
                          className="person-item"
                        >
                          {content}
                        </div>
                      );
                    })}
                    {loading && <p style={{ textAlign: "center" }}>Loading more...</p>}
                    {lastPage && <p style={{ textAlign: "center" }}></p>}
                  </div>

          </div>

          {/* --- RIGHT: CHAT WINDOW --- */}
          <div className="chat-area">
            {/*
              recipientId !== "all" && validPhone(recipientId) ?
              <> … chat header, body, footer … </>
              :
              <> … “No Inbox Selected” state … </>
            */}

            {/* CHAT HEADER */}
            {recipientId === 'all' ? (
              <></>
            ) : (
            
            <div className="chat-header">
              <div className="chat-avatar" style={{ backgroundColor: getRandomColor(recipientId) }}>

                <img 
                                            src={`https://www.aadow.com/icons/profile.png`} 
                                            alt="User Avatar"
                                            className='chat-img'
                                        />

              </div>
              <div className="chat-user-info">
                <span className="chat-user-name">+{recipientId}</span>
              </div>
              <button onClick={() => handleClickOpen(1)} className="delete-chat">Delete Chat</button>
            </div>
            )}
            {/* CHAT BODY */}
            
            <div className="chat-body" /* ref={chatBodyRef} */>
              {/*
                messages.length > 0 ? (
                  messages.reverse().map(msg ⇒
                    <div className={`chat-bubble ${msg.sentBy==="business" ? "me" : "other"}`}>
                      { msg.messageType==="image"
                          ? <img src={imageUrls[msg.messageBody]} className="chat-image"/>
                          : <p>{msg.messageBody}</p>
                      }
                      <h6 className="message-time">
                        {formatTimestamp(msg.createdAt)} · {msg.messageStatus}
                      </h6>
                    </div>
                  )
                ) : (
                  <div className="no-recipient">
                    <div className="error-content">
                      <i className="bi bi-chat-right error-icon" />
                      <h2 className="error-heading">No Messages Yet</h2>
                      <p className="error-subheading">
                        Start a conversation to see your messages here.
                      </p>
                    </div>
                  </div>
                )
              */}
                {messages != "" ? (
                <div ref={chatBoxRef} style={styles.chatBox}>
                    {loadingOlder && hasMore && <div style={styles.loader}>Loading...</div>}
                    {!hasMore && <div style={styles.noMore}>No earlier messages</div>}
                    {messages.map(msg => (
                    <div key={msg.messageId} style={{
                        ...styles.message,
                        alignSelf: msg.sentBy === 'business' ? 'flex-end' : 'flex-start',
                        backgroundColor: msg.sentBy === 'business' ? '#FFF' : '#FFF'
                    }}>

                        <div className={`chat-bubble ${msg.sentBy==="business" ? "customer" : "other"}`}>
                        <p>{msg.messageBody}</p>
                        <h6 className="message-time">
                                                <span>
                          {formatDateTimestamp(msg.createdAt)} {msg.sentBy === "business"  && `· ${msg.messageStatus}`}
                        </span>

                        </h6>
                        </div>

                    </div>
                    ))}
                    <div ref={messagesEndRef} />
                </div>
                ) : (
                  <div className="no-recipient">
                    <div className="error-content">
                      <>
                      {recipientId === 'all' ? (
                        <>
                          <i className="bi bi-chat-right error-icon" />
                          <h2 className="error-heading">No Conversation Selected</h2>
                          <p className="error-subheading">
                            Please select a conversation from the list to view messages.
                          </p>
                        </>
                      ) : (
                        <>
                          <i className="bi bi-chat-right error-icon" />
                          <h2 className="error-heading">No Messages Yet</h2>
                          <p className="error-subheading">
                            Start a conversation to see your messages here.
                          </p>
                        </>
                      )}

                      </>
                      
                    </div>
                  </div>
                )
                }
            </div>

            {/* CHAT FOOTER */}
            {recipientId === 'all' ? (
              <></>
            ) : (
            <div className="chat-footer">
              <input
                type="text"
                className="message-input"
                value={messageInput}
                onChange={e => setMessageInput(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && sendMessage()}
                placeholder="Type a message..."
              />
              <button
                className="send-button"
                onClick={sendMessage}
                // onClick={sendMessage}
                // disabled={isLoading}
              >
                { /* isLoading ? <div className="spinner" /> : <i className="bi bi-send" /> */ }
                Send
              </button>
            </div>
            
            )}
          </div>

        </div>
      </div>
            
            <Dialog open={open} onClose={handleCloseDeleteModal}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                  <DialogContentText>
                    Are you sure you want to delete this Conversation? This action cannot be undone.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCloseDeleteModal} className="text-secondary">
                    Cancel
                  </Button>
                  <Button onClick={handleDeleteConversation} className="text-danger">
                    Delete
                  </Button>
                </DialogActions>
            </Dialog>
            
            <Snackbar open={snackbarOpen} autoHideDuration={5000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
              <MuiAlert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>{snackbarMessage}</MuiAlert>
            </Snackbar>
    </SideBar>
  );
};


const styles = {
  container: { width: '100%', maxWidth: 600, margin: '0 auto', fontFamily: 'Arial, sans-serif' },
  recipientList: { display: 'flex', justifyContent: 'center', margin: '10px 0', gap: '8px' },
  header: { textAlign: 'center', margin: '10px 0' },
  chatBox: {
    display: 'flex',
    flexDirection: 'column',
    height: '85vh',
    overflowY: 'auto',
    padding: '0',
    borderRadius: '8px',
    paddingRight: '10px',
    backgroundColor: '#fff',
    marginBottom: '10px'
  },
  loader: { textAlign: 'center', padding: '8px', color: '#555' },
  noMore: { textAlign: 'center', padding: '8px', color: '#888', fontStyle: 'italic' },
  inputContainer: { display: 'flex' },
  input: { flex: 1, padding: '10px', borderRadius: '20px', border: '1px solid #ccc', marginRight: '8px' },
  button: { padding: '10px 16px', borderRadius: '20px', border: 'none', backgroundColor: '#4CAF50', color: 'white', cursor: 'pointer' }
};

export default InboxTemplate;
